/* RAYZ motion: Lenis on desktop, one scroll loop for every scene, reduced-motion fallbacks.
   Ported from the approved homepage prototype. Each RAYZ section carries data-rz="<scene>"
   and is mounted on load and again when the theme editor re-renders it. */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const G = !!window.gsap && !reduce;
  const cfg = window.RayzSettings || {};
  const html = document.documentElement;
  const isMotion = () => html.classList.contains('motion');
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v)), lerp = (a, b, t) => a + (b - a) * t;
  const easeIn = (t) => t * t * t, easeIO = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const pad = (n) => String(n).padStart(2, '0');
  const ref = (root, name) => root.querySelector(`[data-ref="${name}"]`);
  function mix(hex, base, t) {
    const a = parseInt(hex.slice(1), 16), b = parseInt(base.slice(1), 16);
    const r = Math.round(((a >> 16) & 255) * t + ((b >> 16) & 255) * (1 - t)), g = Math.round(((a >> 8) & 255) * t + ((b >> 8) & 255) * (1 - t)), bl = Math.round((a & 255) * t + (b & 255) * (1 - t));
    return `rgb(${r},${g},${bl})`;
  }
  const dark = () => html.dataset.rzDark === 'auto' && matchMedia('(prefers-color-scheme: dark)').matches;
  const readJSON = (el) => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  /* Muted films start reliably on phones and in-app browsers: try now, again when ready, and again on the
     first touch or scroll. Under reduced motion they stay on the poster. If the phone blocks video outright
     (Low Power Mode), the poster stays. */
  const pending = new Set();
  function ensurePlay(v) {
    if (!v || reduce) return;
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
    const go = () => { const p = v.play(); if (p && p.catch) p.catch(() => pending.add(v)); };
    go();
    if (v.readyState < 3) v.addEventListener('canplay', go, { once: true });
  }
  // Every muted, looping or autoplaying video on the page (ours and app videos such as ReelUp) that the
  // browser refused to start is started by the visitor's first touch or keypress, which phones allow even
  // in Low Power Mode.
  const onScreen = (v) => { const r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.width > 0; };
  const wantsPlay = (v) => v.paused && v.dataset.rzHold !== '1' && !v.closest('.rz-menu') && (pending.has(v) || v.autoplay || v.hasAttribute('data-rz-autoplay') || (v.muted && v.loop));
  const kick = () => {
    if (reduce) return;
    document.querySelectorAll('video').forEach((v) => {
      if (!wantsPlay(v) || !onScreen(v)) return;
      v.muted = true; v.playsInline = true;
      v.play().then(() => pending.delete(v)).catch(() => pending.add(v));
    });
  };
  ['touchstart', 'touchend', 'pointerdown', 'click', 'keydown', 'scroll'].forEach((t) => addEventListener(t, kick, { passive: true, capture: true }));
  // app videos that load later (ReelUp) are nudged once they appear
  if ('MutationObserver' in window && !reduce) {
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(kick, 400); }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) kick(); });
  if (reduce) document.querySelectorAll('video[autoplay]').forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
  window.RayzPlay = ensurePlay;

  /* ---------------- smooth scroll ---------------- */
  let lenis = null;
  const hasScenes = () => !!document.querySelector('.rz-scene');
  if (window.Lenis && fine && !reduce && cfg.smoothScroll !== false && !(window.Shopify && Shopify.designMode) && hasScenes()) {
    lenis = new Lenis({ lerp: 0.08, smoothWheel: true, wheelMultiplier: 0.9 });
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(performance.now());
  }
  function goTo(y) {
    if (lenis) lenis.scrollTo(y, { duration: 1.8, easing: (t) => 1 - Math.pow(1 - t, 4) });
    else scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }
  window.RayzScroll = { goTo, lenis };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.hash.length < 2) return;
    let t = null;
    try { t = document.querySelector(decodeURIComponent(url.hash)); } catch (err) { return; }
    if (!t) return;
    e.preventDefault();
    const cart = document.querySelector('cart-drawer');
    if (cart && cart.close) cart.close();
    goTo(t.getBoundingClientRect().top + scrollY);
  });

  /* ---------------- shared state ---------------- */
  const scenes = new Map();
  let opens = [], lbImgs = [];
  function collect() {
    opens = [...document.querySelectorAll('[data-rz-open]')];
    lbImgs = [...document.querySelectorAll('.rz-lb-track figure img')];
  }

  const cardIO = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    cardIO.unobserve(e.target);
    e.target.classList.add('is-in');
  }), { rootMargin: '0px 0px -8% 0px' });

  /* reveal helper */
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    io.unobserve(e.target);
    if (G) gsap.from(e.target.querySelectorAll('.rz-mask > span'), { yPercent: 110, rotate: 3, duration: 1.6, ease: 'expo.out', stagger: 0.1 });
  }), { rootMargin: '0px 0px -12% 0px' });

  /* ---------------- 1 · the R aperture ---------------- */
  const MONO = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 574 479"><mask id="m"><rect width="574" height="479" fill="#fff"/><g fill="#000"><rect x="0" y="97" width="474" height="28"/><rect x="446" y="97" width="28" height="153"/><rect x="98" y="222" width="376" height="28"/><rect x="98" y="222" width="30" height="257"/><polygon points="128,350 378,350 463,479 128,479"/><polygon points="494,352 574,352 574,380 504,380"/></g></mask><rect width="574" height="479" fill="#000" mask="url(#m)"/></svg>`;
  const MURL = `url("data:image/svg+xml,${encodeURIComponent(MONO)}")`;
  const A = 574 / 479;

  function aperture(el) {
    const win = ref(el, 'win'), type = ref(el, 'type'), w1 = ref(el, 'w1'), w2 = ref(el, 'w2'), foot = ref(el, 'foot'), shade = ref(el, 'shade'), fin = ref(el, 'final');
    const reelN = ref(el, 'reelN'), reelBar = ref(el, 'reelBar');
    const slides = readJSON(ref(el, 'slides')) || [];
    const media = [...ref(el, 'fb').children];
    const hold = (i) => ((slides[i] && slides[i].h) || 6) * 1000;
    const timers = [];
    let alive = true;
    win.style.webkitMaskImage = MURL; win.style.maskImage = MURL;

    function set(p) {
      const W = innerWidth, H = innerHeight, wide = W >= 900;
      const h0 = wide ? Math.min(H * 0.6, (W * 0.42) / A) : Math.min(H * 0.4, (W * 0.8) / A), h1 = Math.max(H * 6.4, (W / A) * 1.2);
      const e = easeIn(clamp(p / 0.62));
      const cx0 = wide ? W * 0.71 : W * 0.5, cy0 = wide ? H * 0.5 : H * 0.5;
      if (e >= 0.999) { win.style.webkitMaskImage = 'none'; win.style.maskImage = 'none'; }
      else {
        if (win.style.maskImage === 'none') { win.style.webkitMaskImage = MURL; win.style.maskImage = MURL; }
        const h = h0 * Math.pow(h1 / h0, e), w = h * A, fx = 0.5, fy = lerp(0.5, 0.1, e);
        const cx = lerp(cx0, W * 0.5, e), cy = lerp(cy0, H * 0.5, e);
        win.style.webkitMaskSize = win.style.maskSize = `${w}px ${h}px`;
        win.style.webkitMaskPosition = win.style.maskPosition = `${cx - fx * w}px ${cy - fy * h}px`;
      }
      // words part and fade
      const t = clamp(p / 0.5);
      w1.style.transform = `translateX(${-t * 30}vw)`;
      w2.style.transform = `translateX(${-t * 48}vw)`;
      type.style.opacity = 1 - clamp((p - 0.15) / 0.3);
      foot.style.opacity = 1 - clamp(p / 0.2);
      foot.style.pointerEvents = p > 0.1 ? 'none' : '';
      shade.style.opacity = clamp((p - 0.45) / 0.3);
      const f = clamp((p - 0.6) / 0.22);
      fin.style.opacity = f; fin.style.pointerEvents = f > 0.5 ? 'auto' : 'none';
      fin.style.transform = `translateY(${(1 - f) * 30}px)`;
    }
    set(0);

    /* liquid-swipe WebGL reel over images or video (falls back to cross-fading the media) */
    let reelIdx = 0, glOK = false, fading = false, raf = 0;
    const videos = media.filter((m) => m.tagName === 'VIDEO');
    function reelUI() {
      if (reelN) reelN.textContent = pad(reelIdx + 1);
      if (G && reelBar) gsap.fromTo(reelBar, { scaleX: 0 }, { scaleX: 1, duration: hold(reelIdx) / 1000, ease: 'none' });
    }
    let visible = true;
    const vio = new IntersectionObserver((es) => {
      visible = es[0].isIntersecting;
      videos.forEach((v) => { if (reduce) return; if (visible) { v.dataset.rzHold = '0'; ensurePlay(v); } else { v.dataset.rzHold = '1'; v.pause(); } });
    });
    vio.observe(el);

    // each slide holds for its own time; films start from their first frame when they come round
    function every(step) {
      const next = () => timers.push(setTimeout(() => { step(); next(); }, hold(reelIdx)));
      next();
    }
    function rewind(i) { const m = media[i]; if (m && m.tagName === 'VIDEO') { try { m.currentTime = 0; } catch (e) {} ensurePlay(m); } }
    function crossfade() {
      if (glOK || fading || media.length < 2) return;
      fading = true;
      every(() => {
        media[reelIdx].classList.remove('is-on');
        reelIdx = (reelIdx + 1) % media.length;
        rewind(reelIdx);
        media[reelIdx].classList.add('is-on');
        reelUI();
      });
      reelUI();
    }

    (function initGL() {
      if (reduce || slides.length < 2) return;
      const cv = ref(el, 'gl'), gl = cv.getContext('webgl', { premultipliedAlpha: false, antialias: false });
      if (!gl) return;
      const vs = 'attribute vec2 p;varying vec2 v;void main(){v=p*.5+.5;gl_Position=vec4(p,0.,1.);}';
      const fs = `precision mediump float;varying vec2 v;uniform sampler2D ta,tb;uniform vec2 res,sa,sb,fa,fb;uniform float t,za,zb;
      float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
      float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}
      vec2 cover(vec2 uv,vec2 s,vec2 fo,float z){float rs=res.x/res.y,ri=s.x/s.y;vec2 k=rs>ri?vec2(1.,ri/rs):vec2(rs/ri,1.);uv=(uv-.5)/z+.5;return (1.-k)*fo+uv*k;}
      void main(){
        float nn=n(v*vec2(2.5,7.))*.6+n(v*vec2(9.,18.))*.4;
        float d=v.x*.8+(1.-v.y)*.2+(nn-.5)*.35;
        float m=1.-smoothstep(t*1.6-.3,t*1.6-.05,d);
        float edge=m*(1.-m)*4.;
        vec2 dir=vec2(1.,.15);
        vec2 ua=cover(v+dir*edge*.05,sa,fa,za);
        vec2 ub=cover(v-dir*(1.-m)*.12,sb,fb,zb);
        vec4 ca=texture2D(ta,ua),cb=texture2D(tb,ub);
        vec3 c=mix(ca.rgb,cb.rgb,m)+edge*.035;
        gl_FragColor=vec4(c,1.);
      }`;
      function sh(type, src) { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; }
      const v = sh(gl.VERTEX_SHADER, vs), f = sh(gl.FRAGMENT_SHADER, fs);
      if (!v || !f) return;
      const pr = gl.createProgram(); gl.attachShader(pr, v); gl.attachShader(pr, f); gl.linkProgram(pr);
      if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
      gl.useProgram(pr);
      const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      const U = (k) => gl.getUniformLocation(pr, k);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      const tex = [], size = [], src = [];
      let loaded = 0, failed = false;
      function upload(i) {
        gl.bindTexture(gl.TEXTURE_2D, tex[i]);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, src[i]);
      }
      function ready(i, source, w, h) {
        if (failed) return;
        const tx = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tx);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        tex[i] = tx; size[i] = [w, h]; src[i] = source;
        try { upload(i); } catch (err) { failed = true; return; } // a tainted (non-CORS) source keeps the cross-fade
        if (++loaded === slides.length) start();
      }
      slides.forEach((s, i) => {
        const m = media[i];
        if (s.t === 'video' && m && m.tagName === 'VIDEO') {
          const go = () => ready(i, m, m.videoWidth, m.videoHeight);
          if (m.readyState >= 2) go(); else m.addEventListener('loadeddata', go, { once: true });
          m.play().catch(() => {});
        } else {
          const im = new Image(); im.crossOrigin = 'anonymous';
          im.onload = () => ready(i, im, im.naturalWidth, im.naturalHeight);
          im.src = s.src;
        }
      });
      function resize() { const d = Math.min(devicePixelRatio || 1, 2); cv.width = cv.clientWidth * d; cv.height = cv.clientHeight * d; gl.viewport(0, 0, cv.width, cv.height); }
      let a = 0, b = 1, t = 0, ta0 = performance.now(), tb0 = performance.now(), trans = null;
      function draw(now) {
        if (!alive) return;
        if (visible) {
          const zA = 1.1 - 0.08 * Math.min((now - ta0) / 9000, 1), zB = 1.1 - 0.08 * Math.min((now - tb0) / 9000, 1);
          if (src[a].tagName === 'VIDEO') upload(a);
          if (trans && src[b].tagName === 'VIDEO') upload(b);
          gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tex[a]); gl.uniform1i(U('ta'), 0);
          gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, tex[b]); gl.uniform1i(U('tb'), 1);
          gl.uniform2f(U('res'), cv.width, cv.height); gl.uniform2f(U('sa'), ...size[a]); gl.uniform2f(U('sb'), ...size[b]);
          gl.uniform2f(U('fa'), slides[a].fx, 1 - slides[a].fy); gl.uniform2f(U('fb'), slides[b].fx, 1 - slides[b].fy);
          gl.uniform1f(U('za'), zA); gl.uniform1f(U('zb'), zB);
          if (trans) { t = clamp((now - trans) / 1800); if (t >= 1) { a = b; ta0 = tb0; trans = null; t = 0; } }
          gl.uniform1f(U('t'), trans ? easeIO(t) : 0);
          gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        }
        raf = requestAnimationFrame(draw);
      }
      function start() {
        if (fading || !alive) return;
        glOK = true; resize(); addEventListener('resize', resize);
        ref(el, 'fb').style.visibility = 'hidden';
        raf = requestAnimationFrame(draw);
        every(() => { if (trans) return; b = (a + 1) % slides.length; rewind(b); tb0 = performance.now(); trans = performance.now(); reelIdx = b; reelUI(); });
        reelUI();
      }
    })();
    if (!reduce) timers.push(setTimeout(crossfade, 2500));

    /* hero intro (from a readable start) */
    if (G) {
      const wait = html.classList.contains('rz-intro-on') ? (document.querySelector('.rz-intro[data-tips="true"]') ? 3.2 : 1.55) : 0;
      gsap.from(type.querySelectorAll('.rz-mask > span'), { yPercent: wait ? 110 : 40, duration: 2, ease: 'expo.out', stagger: 0.12, delay: 0.1 + wait });
      gsap.from(win, { scale: wait ? 0.84 : 0.92, duration: 2.2, ease: 'expo.out', delay: wait });
      gsap.from(foot.children, { y: 16, autoAlpha: 0, duration: 1.6, ease: 'expo.out', stagger: 0.1, delay: 0.4 + wait });
    }

    return {
      kind: 'aperture',
      tick(H) {
        const r = el.getBoundingClientRect();
        if (isMotion()) {
          const p = clamp(-r.top / (el.offsetHeight - H)); set(p);
          return { cover: r.bottom > 60, light: r.bottom > 60 && p > 0.42 };
        }
        return { cover: r.bottom >= 60, light: false };
      },
      destroy() { alive = false; cancelAnimationFrame(raf); timers.forEach((id) => { clearInterval(id); clearTimeout(id); }); vio.disconnect(); },
    };
  }

  /* ---------------- 2 · statement words ---------------- */
  function statement(el) {
    const st = ref(el, 'text');
    (function wrap(node) {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const fr = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((t) => {
            if (!t) return;
            if (/^\s+$/.test(t)) fr.appendChild(document.createTextNode(t));
            else { const s = document.createElement('span'); s.className = 'rz-wd'; s.textContent = t; fr.appendChild(s); }
          });
          n.replaceWith(fr);
        } else wrap(n);
      });
    })(st);
    const words = [...st.querySelectorAll('.rz-wd')];
    return {
      tick(H) {
        const sr = st.getBoundingClientRect(), sp = clamp((H * 0.85 - sr.top) / (sr.height + H * 0.35));
        words.forEach((w, i) => w.style.setProperty('--o', reduce ? 1 : 0.16 + 0.84 * clamp(sp * words.length * 1.15 - i)));
      },
    };
  }

  /* ---------------- 3 · shade theatre: the fanned deck ---------------- */
  /* One card per shade, fanned like a hand of cards around the front one. As the section arrives the deck
     spreads out from behind the front card; once pinned, scroll scrubs one continuous position through the
     shades (each rests briefly, then hands over), gliding the next card to the front, where it grows, comes
     forward and turns from its on-set photo into the pack shot. The name cascades letter by letter, the
     counter rolls and the ground blends between the two colours. Everything is a pure function of the
     position, so it runs backwards as smoothly as forwards. */
  function theatre(el) {
    const SH = readJSON(ref(el, 'shades')) || [];
    if (!SH.length) return null;
    const N = SH.length;
    const deck = ref(el, 'deck'), cards = [...el.querySelectorAll('.rz-dk')];
    const nmBox = ref(el, 'nm'), moodBox = ref(el, 'mood'), odo = ref(el, 'odo'), live = ref(el, 'live'), flood = ref(el, 'flood');
    const price = ref(el, 'price'), cmp = ref(el, 'cmp'), add = ref(el, 'add'), idInput = ref(el, 'id');
    const ticks = [...el.querySelectorAll('.rz-tick')];
    const addLabel = el.dataset.addLabel || 'Add to bag', soldLabel = el.dataset.soldLabel || 'Sold out';
    const esc = (t) => String(t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]);

    nmBox.innerHTML = SH.map((s) => `<span class="rz-nm-l" aria-hidden="true">${s.n.split(' ').map((w) => `<span class="rz-wdw">${[...w].map((c) => `<span class="rz-ch"><span>${esc(c)}</span></span>`).join('')}</span>`).join(' ')}</span>`).join('');
    const nmL = [...nmBox.children], nmC = nmL.map((l) => [...l.querySelectorAll('.rz-ch > span')]);
    moodBox.innerHTML = SH.map((s) => `<span class="rz-mood-l" aria-hidden="true">${esc(s.m)}</span>`).join('');
    const moodL = [...moodBox.children];
    if (odo) odo.innerHTML = SH.map((_, i) => `<i>${pad(i + 1)}</i>`).join('');
    const parts = cards.map((c) => ({ set: c.querySelector('.rz-dk-set'), pack: c.querySelector('.rz-dk-pack'), cap: c.querySelector('.rz-dk-cap') }));
    ticks.forEach((t, j) => t.style.setProperty('--c', SH[j].c));

    const ground = SH.map((s) => (dark() ? mix(s.c, '#110F0F', 0.14) : mix(s.c, '#F7F2EE', 0.1)).match(/\d+/g).map(Number));
    const blend = (a, b, t) => `rgb(${a.map((v, k) => Math.round(v + (b[k] - v) * t)).join(',')})`;
    function buyState(s) {
      if (price) price.textContent = s.price;
      const fo = ref(el, 'fo'); const fob = fo && fo.querySelector('[data-rz-fp-price]'); if (fob && s.fp) fob.textContent = s.fp;
      if (cmp) { cmp.textContent = s.cmp || ''; cmp.hidden = !s.cmp; }
      if (idInput && s.id) idInput.value = s.id;
      if (add) { add.disabled = s.id ? !s.avail : false; add.querySelector('span').textContent = s.id && !s.avail ? soldLabel : addLabel; }
    }

    const PLATEAU = 0.34;
    const mapU = (u) => { const i = Math.floor(u); if (i >= N - 1) return N - 1; const f = u - i; return i + easeIO(clamp((f - PLATEAU / 2) / (1 - PLATEAU))); };
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    let cur = 0, tgt = 0, spread = reduce ? 1 : 0, tSpread = spread, shown = -1, last = '', dir = 1;
    let rx = 0, ry = 0, trx = 0, try_ = 0, sh = 0, tsh = 0;

    function draw(s, sp) {
      const i0 = Math.min(N - 1, Math.floor(s)), f = s - i0, i1 = Math.min(N - 1, i0 + 1);
      el.style.setProperty('--tint', blend(ground[i0], ground[i1], f));
      if (flood) {
        const w = Math.sin(Math.PI * f), to = dir >= 0 ? i1 : i0;
        flood.style.setProperty('--flood', SH[to].c);
        flood.style.opacity = (w * 0.45).toFixed(3);
        flood.style.transform = `translate3d(${(dir >= 0 ? 1 - f : f) * 18 - 6}%, 0, 0) scale(${0.7 + w * 0.5})`;
      }
      if (odo) odo.style.transform = `translate3d(0, ${-s}em, 0)`;

      // the deck: a fan around the front card, compressed toward the edges
      const cw = cards[0].offsetWidth, phone = innerWidth < 700;
      const step = cw * (phone ? 0.74 : 0.66);
      cards.forEach((c, i) => {
        const d = i - s, ad = Math.abs(d), sg = d < 0 ? -1 : 1;
        if (ad > 3.6) { c.style.visibility = 'hidden'; return; }
        c.style.visibility = 'visible';
        const fan = sg * step * (ad <= 1 ? ad : 1 + (ad - 1) * 0.7);
        const x = fan * sp + sg * Math.min(ad, 3) * 10 * (1 - sp); // stacked: each card peeks a few px out
        const scFan = 1 - Math.min(ad, 3) * 0.13, scStack = 1 - Math.min(ad, 3) * 0.05;
        const sc = lerp(scStack, scFan, sp);
        const front = 1 - clamp(ad * 2);
        const rY = clamp(d, -1.5, 1.5) * -7 * sp + ry * front, rX = rx * front;
        const lift = (1 - clamp(ad)) * -2;
        c.style.transform = `translate3d(calc(-50% + ${x.toFixed(1)}px), ${lift.toFixed(2)}%, 0) rotateY(${rY.toFixed(2)}deg) rotateX(${rX.toFixed(2)}deg) scale(${sc.toFixed(4)})`;
        c.style.zIndex = String(100 - Math.round(ad * 10));
        c.style.opacity = clamp(3.6 - ad).toFixed(3);
        c.style.setProperty('--front', front.toFixed(3));
        c.style.setProperty('--sh', (front * sh).toFixed(3));
        const m = clamp((ad - 0.06) * 1.8); // 0 at the front: the pack shot; 1 away from it: the on-set photo
        const p = parts[i];
        p.pack.style.opacity = (1 - m).toFixed(3);
        p.pack.style.transform = `scale(${(1.06 - 0.06 * (1 - m)).toFixed(4)})`;
        p.set.style.transform = `scale(${(1 + 0.08 * (1 - m)).toFixed(4)})`;
        p.cap.style.opacity = m.toFixed(3);
      });

      // name, mood
      for (let i = 0; i < N; i++) {
        const d = i - s, nl = nmL[i], ml = moodL[i];
        if (d <= -1 || d >= 1) { nl.style.visibility = 'hidden'; ml.style.visibility = 'hidden'; continue; }
        nl.style.visibility = ml.style.visibility = 'visible';
        const cs = nmC[i], K = cs.length, st = Math.min(0.05, 0.45 / Math.max(1, K)), span = 1 - st * (K - 1);
        const q = d >= 0 ? clamp((1 - d - 0.4) / 0.6) : clamp(-d / 0.6);
        for (let k = 0; k < K; k++) { const e = ease(clamp((q - k * st) / span)); cs[k].style.transform = `translate3d(0, ${(d >= 0 ? (1 - e) * 112 : -e * 112).toFixed(2)}%, 0)`; }
        const m = d >= 0 ? ease(clamp((1 - d - 0.45) / 0.55)) : 1 - ease(clamp(-d / 0.5));
        ml.style.opacity = m.toFixed(3); ml.style.transform = `translate3d(0, ${((d >= 0 ? 1 - m : m - 1) * 50).toFixed(2)}%, 0)`;
      }
      ticks.forEach((t, j) => t.style.setProperty('--f', clamp(s - j + 1).toFixed(3)));
      const idx = Math.round(s);
      if (idx !== shown) {
        shown = idx; const shd = SH[idx];
        cards.forEach((c, j) => c.classList.toggle('is-on', j === idx));
        ticks.forEach((t, j) => { t.classList.toggle('is-on', j === idx); t.setAttribute('aria-pressed', j === idx); });
        buyState(shd);
        if (live) live.textContent = `${shd.n}. ${shd.m}`;
      }
    }

    // the front card leans toward the cursor, with a sheen that follows it
    if (fine && !reduce) {
      deck.addEventListener('pointermove', (e) => {
        const c = cards[shown < 0 ? 0 : shown], r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        if (x < -0.1 || x > 1.1 || y < -0.1 || y > 1.1) { trx = try_ = 0; tsh = 0; return; }
        try_ = (x - 0.5) * 12; trx = (0.5 - y) * 9; tsh = 1;
        c.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`); c.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
      });
      deck.addEventListener('pointerleave', () => { trx = try_ = 0; tsh = 0; });
    }

    const jump = (i) => {
      if (isMotion()) {
        const top = el.getBoundingClientRect().top + scrollY, len = el.offsetHeight - innerHeight;
        goTo(top + len * (N > 1 ? i / (N - 1) : 0));
      } else { cur = tgt = i; last = ''; }
    };
    cards.forEach((c, i) => c.addEventListener('click', () => { if (i !== shown) jump(i); }));
    ticks.forEach((b, i) => b.addEventListener('click', () => jump(i)));
    const form = ref(el, 'form');
    if (form) form.addEventListener('submit', (e) => {
      e.preventDefault();
      const s = SH[shown < 0 ? 0 : shown], cart = document.querySelector('cart-drawer');
      if (!s.id) { window.RayzToast && RayzToast(el.dataset.demoMsg || 'Choose the lipstick product for this section in the theme editor'); return; }
      if (cart && cart.add) cart.add(s.id, 1, s.n); else form.submit();
    });

    draw(0, spread);
    return {
      tick(H) {
        const r = el.getBoundingClientRect();
        if (r.bottom < -H || r.top > H * 2) return;
        if (isMotion()) {
          const len = Math.max(1, el.offsetHeight - H);
          tgt = mapU(clamp(-r.top / len) * (N - 1));
          tSpread = reduce ? 1 : easeIO(clamp((H * 0.95 - r.top) / (H * 0.85)));
        } else tSpread = 1;
        const k = reduce ? 1 : 0.16;
        const prev = cur;
        cur = Math.abs(tgt - cur) < 0.0004 ? tgt : lerp(cur, tgt, k);
        spread = Math.abs(tSpread - spread) < 0.001 ? tSpread : lerp(spread, tSpread, k);
        if (cur !== prev) dir = cur > prev ? 1 : -1;
        if (fine && !reduce) { rx = lerp(rx, trx, 0.08); ry = lerp(ry, try_, 0.08); sh = lerp(sh, tsh, 0.06); }
        const key = `${cur.toFixed(4)}|${spread.toFixed(4)}|${rx.toFixed(2)}|${ry.toFixed(2)}|${sh.toFixed(2)}|${innerWidth}`;
        if (key !== last) { last = key; draw(cur, spread); }
      },
    };
  }

  /* ---------------- 5 · lookbook ---------------- */
  let vel = 0, skew = 0;
  function lookbook(el) {
    const track = ref(el, 'track'), prog = ref(el, 'prog');
    let lbX = 0;
    const size = () => { if (isMotion()) el.style.height = track.scrollWidth - innerWidth + innerHeight * 1.15 + 'px'; };
    size(); addEventListener('resize', size); addEventListener('load', size);
    track.querySelectorAll('img').forEach((im) => { if (!im.complete) im.addEventListener('load', size, { once: true }); });
    // drag scrubs the page, which scrubs the track
    let down = false, sx = 0;
    if (fine && !reduce) {
      const lab = document.querySelector('.rz-cur-lab');
      track.addEventListener('pointerdown', (e) => { down = true; sx = e.clientX; if (lab) lab.textContent = ''; });
      addEventListener('pointerup', () => { if (down && lab) lab.textContent = track.dataset.cur || 'Drag'; down = false; });
      addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; sx = e.clientX; if (lenis) lenis.scrollTo(scrollY - dx * 1.6, { immediate: true }); else scrollBy(0, -dx * 1.6); });
      track.addEventListener('dragstart', (e) => e.preventDefault());
    }
    return {
      tick(H) {
        if (!isMotion()) return null;
        const lr = el.getBoundingClientRect(), lp = clamp(-lr.top / (el.offsetHeight - H));
        const max = track.scrollWidth - innerWidth; lbX = lerp(lbX, -lp * max, 0.14);
        track.style.transform = `translate3d(${lbX}px,0,0)`;
        track.querySelectorAll('figure').forEach((f) => { f.style.transform = `skewX(${-skew * 0.6}deg) scaleY(${1 + Math.abs(skew) * 0.006})`; });
        prog.style.transform = `scaleX(${lp})`;
        el.style.setProperty('--lbbg', mix('#5A0F17', '#121010', clamp(lp * 1.2)));
        const inLb = lr.top < 60 && lr.bottom > 60;
        return { cover: inLb, light: inLb };
      },
      destroy() { removeEventListener('resize', size); removeEventListener('load', size); },
    };
  }

  /* ---------------- 7 · finale wordmark rises out of its line ---------------- */
  function finale(el) {
    const mark = ref(el, 'mark'), imgs = [...mark.querySelectorAll('img')];
    return {
      tick(H) {
        const fm = mark.getBoundingClientRect(), fq = clamp((H - fm.top) / (fm.height * 1.4 + H * 0.2));
        mark.style.setProperty('--cl', reduce ? '0%' : ((1 - easeIO(fq)) * 100).toFixed(1) + '%');
        imgs.forEach((im) => { im.style.transform = reduce ? 'none' : `translateY(${(1 - easeIO(fq)) * 30}%)`; });
      },
    };
  }

  const factories = { aperture, statement, theatre, lookbook, finale };

  /* films outside the reel: play while on screen, never under reduced motion (the poster stays) */
  const vidIO = new IntersectionObserver((es) => es.forEach((e) => { if (reduce) return; if (e.isIntersecting) { e.target.dataset.rzHold = '0'; ensurePlay(e.target); } else { e.target.dataset.rzHold = '1'; e.target.pause(); } }), { rootMargin: '10% 0px' });
  const watchFilms = (root) => root.querySelectorAll('video[data-rz-autoplay]').forEach((v) => vidIO.observe(v));

  function mount(root) {
    root.querySelectorAll('[data-rz]').forEach((el) => {
      if (scenes.has(el)) return;
      const f = factories[el.dataset.rz];
      const s = f && f(el);
      if (s) scenes.set(el, s);
    });
    if (G) root.querySelectorAll('[data-rise]').forEach((el) => { if (el.getBoundingClientRect().top > innerHeight) io.observe(el); });
    // headings already on screen rise as the page arrives
    if (G) root.querySelectorAll('[data-intro]').forEach((el) => {
      if (el.dataset.introDone) return; el.dataset.introDone = '1';
      gsap.from(el.querySelectorAll('.rz-mask > span'), { yPercent: 110, duration: 1.6, ease: 'expo.out', stagger: 0.08, delay: 0.1 });
    });
    // product cards step in, four to a beat
    if (!reduce) {
      html.classList.add('rz-reveal');
      root.querySelectorAll('[data-rz-cards] .rz-card, [data-rz-cards] .rz-tile').forEach((c) => cardIO.observe(c));
    }
    watchFilms(root);
    collect();
  }
  function unmount(root) {
    root.querySelectorAll('[data-rz]').forEach((el) => { const s = scenes.get(el); if (s && s.destroy) s.destroy(); scenes.delete(el); });
    collect();
  }
  mount(document);
  document.addEventListener('shopify:section:load', (e) => { mount(e.target); if (lenis) lenis.resize(); });
  document.addEventListener('shopify:section:unload', (e) => unmount(e.target));
  document.addEventListener('rayz:content', (e) => mount((e.detail && e.detail.root) || document));

  /* ---------------- header ---------------- */
  let hdr = null, overlay = false;
  function header() {
    hdr = document.querySelector('.rz-hdr');
    overlay = !!hdr && hdr.dataset.overlay === 'true';
    document.body.classList.toggle('rz-overlay-header', overlay && !!document.querySelector('[data-rz="aperture"]'));
  }
  header();
  document.addEventListener('shopify:section:load', header);
  document.addEventListener('shopify:section:unload', () => setTimeout(header));

  /* ---------------- one scroll loop drives everything ---------------- */
  let lastY = scrollY;
  function loop() {
    const y = scrollY, H = innerHeight;
    vel = lerp(vel, y - lastY, 0.2); lastY = y;
    skew = lerp(skew, clamp(vel * 0.06, -6, 6), 0.12);
    let cover = false, light = false, hasAp = false;
    scenes.forEach((s) => {
      const r = s.tick(H);
      if (s.kind === 'aperture') hasAp = true;
      if (r) { cover = cover || r.cover; light = light || r.light; }
    });
    if (overlay) {
      if (!hasAp) { hdr.classList.add('is-solid'); hdr.classList.toggle('is-light', false); }
      else { hdr.classList.toggle('is-light', dark() || (isMotion() && light)); hdr.classList.toggle('is-solid', !cover); }
    }
    // images open from an inset frame + inner parallax
    opens.forEach((box) => {
      const img = box.querySelector('img, video'), r = box.getBoundingClientRect();
      if (!img || r.bottom < 0 || r.top > H) return;
      const o = clamp((H - r.top) / (H * 0.75)), k = reduce ? 0 : (1 - easeIO(o)) * 9;
      box.style.clipPath = `inset(${k}% ${k}% ${k}% ${k}%)`;
      if (box.dataset.rzOpen === 'frame') return; // product shots: open the frame, never crop the pack
      const par = clamp((H - r.top) / (H + r.height));
      img.style.transform = reduce ? 'none' : `scale(${1.16 - 0.14 * par})`;
    });
    // lookbook inner zoom
    lbImgs.forEach((im) => {
      const r = im.parentElement.getBoundingClientRect(), q = clamp((innerWidth - r.left) / (innerWidth + r.width));
      im.style.transform = reduce ? 'none' : `scale(${1.14 - 0.12 * q}) translateX(${(q - 0.5) * -6}%)`;
    });
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  /* ---------------- cursor ---------------- */
  const c = document.querySelector('.rz-cur');
  if (c && fine && !reduce) {
    const lab = c.querySelector('.rz-cur-lab');
    let x = -100, yy = -100, tx = -100, ty = -100;
    addEventListener('pointermove', (e) => {
      tx = e.clientX; ty = e.clientY; c.style.opacity = 1;
      const t = e.target.closest('[data-cur]');
      c.classList.toggle('is-big', !!t);
      if (t) lab.textContent = t.dataset.cur;
    });
    document.addEventListener('pointerleave', () => { c.style.opacity = 0; });
    (function f() { x = lerp(x, tx, 0.18); yy = lerp(yy, ty, 0.18); c.style.transform = `translate3d(${x}px,${yy}px,0)`; requestAnimationFrame(f); })();
  }
})();
